import { put, all, call, takeLeading, takeLatest } from 'redux-saga/effects';

import { DataState } from '@shared/enums/DataState';
import { acceptTermsOfUse, getCurrentUser, checkCurrentLocation, setCurrentUser, trackEvent } from './actions';
import {
  fetchCurrentUser,
  postAcceptTermsOfUse,
  postCheckCurrentLocation,
  trackUserEvent,
} from '@modules/App/api/currentUser';
import { setLocationNotMatchingSince, setTermsOfUseAcceptedVersion } from './reducers';
import { User } from '@shared/interfaces/user';
import { getErrorInfo } from '@shared/helpers/getErrorInfo';

function* getCurrentUserAsync() {
  try {
    yield put(setCurrentUser({ data: null, state: DataState.Pending }));
    const response: User = yield call(fetchCurrentUser);
    yield put(setCurrentUser({ data: response, state: DataState.Fulfilled }));
  } catch (error) {
    yield put(setCurrentUser({ data: null, state: DataState.Rejected, error: getErrorInfo(error) }));
  }
}

function* checkCurrentLocationAsync({ payload }: ReturnType<typeof checkCurrentLocation>) {
  const locationNotMatchingSince: string = yield call(postCheckCurrentLocation, payload);
  yield put(setLocationNotMatchingSince(locationNotMatchingSince));
}

function* acceptTermsOfUseAsync({ payload }: ReturnType<typeof acceptTermsOfUse>) {
  yield call(postAcceptTermsOfUse, payload);
  yield put(setTermsOfUseAcceptedVersion(payload));
}

export function* trackEventAsync({ payload }: ReturnType<typeof trackEvent>) {
  yield call(trackUserEvent, payload);
}

function* watchGetCurrentUser() {
  yield takeLatest(checkCurrentLocation.type, checkCurrentLocationAsync);
  yield takeLeading(getCurrentUser.type, getCurrentUserAsync);
  yield takeLatest(acceptTermsOfUse.type, acceptTermsOfUseAsync);
  yield takeLatest(trackEvent.type, trackEventAsync);
}

export function* userSaga(): Generator {
  yield all([watchGetCurrentUser()]);
}
